import TradingRulesDetail from './trading-rules-detail/trading-rules-detail.vue';
import TradingRulesList from './trading-rules-list/trading-rules-list.vue';
export default [
  {
    path: 'trading-rules-list/:type',
    name: 'tradingRulesList',
    component: TradingRulesList,
    meta: {
      title: '政策文件',
      breadCrumbShowIndexArr: [0, 1]  // 面包屑
    }
  },
  {
    path: 'trading-rules-detail',
    name: 'tradingRulesDetail',
    component: TradingRulesDetail,
    meta: {
      title: '规则详情',
      breadCrumbShowIndexArr: [0, 1, 3]
    }
  }
];
